module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic-img"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('a', {
      staticStyle: {
        "display": "block",
        "width": "100%",
        "height": "100%"
      },
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "src": _vm.isMobile ? item.m_img : item.pc_img,
        "alt": ""
      }
    })])])
  }), _vm._v(" "), (_vm.items.length !== 1) ? _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58946e20","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/picSwipe.vue
// module id = 453
// module chunks = 1